import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "../base-component";
import {MesHttpStatusHandlerService} from "../mes-http-status-handler.service";
import {ActiveToast, ToastContainerDirective, ToastrService} from "ngx-toastr";
import {BehaviorSubject, fromEvent, Observable} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ApiMessage, ApiResponse} from "../api-response/api-response.model";

@Component({
  selector: 'app-global-status-handling',
  templateUrl: './global-status-handling.component.html',
  styles: []
})
export class GlobalStatusHandlingComponent extends BaseComponent implements OnInit {
  @ViewChild(ToastContainerDirective, {static: true}) toastContainer: ToastContainerDirective;
  private onlineEvent$: Observable<Event>;
  private offlineEvent$: Observable<Event>;
  private state: 'Offline' | 'Online' = 'Online';

  public response$ = new BehaviorSubject<ApiResponse<any>>(null);
  public clear$ = new BehaviorSubject<boolean>(false);
  private stateToast: ActiveToast<any>;

  constructor(private mesHttpStatusHandlerService: MesHttpStatusHandlerService, private toastrService: ToastrService) {
    super();

    mesHttpStatusHandlerService.httpResponse.subscribe((value: any) => {
      const response = value.body || value.error;
      if (this.state == 'Online') {
        this.addMessagesFromResponse(response);
      }
    });

    mesHttpStatusHandlerService.httpError.subscribe(value => {
      if (this.state == 'Online') {
        this.addMessagesFromResponse(value.error);
      }
    });

    mesHttpStatusHandlerService.http403.subscribe(value => {
      if (this.state == 'Online') {
        const message = new ApiMessage({Messages: ["Sorry, you do not have the necessary permissions to access this page"], Model: value});
        this.response$.next(new ApiResponse<any>({
          status: 403,
          Errors: [message]
        }));
      }
    });

    this.mesHttpStatusHandlerService.clear.subscribe(value => {
      this.clear$.next(value)
    });

    this.mesHttpStatusHandlerService.globalError.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      let message = value.message;
      if(value.type == 'FailedToNegotiateWithServerError'){
        message = 'Failed to complete negotiation with the server';
        this.handleOffline();
      }

      if (value.type == 'FailedToNegotiateWithServerError' && this.state == 'Offline') {
        return;
      }

      this.response$.next(new ApiResponse<any>({
        status: value.status,
        Errors: [new ApiMessage({Messages: [message], Model: JSON.stringify(value)})]
      }));
    })
  }

  ngOnInit(): void {
    this.toastrService.overlayContainer = this.toastContainer;
    this.onlineEvent$ = fromEvent(window, 'online');
    this.offlineEvent$ = fromEvent(window, 'offline');

    this.offlineEvent$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.handleOffline();
    })
    this.onlineEvent$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.state = 'Online';
      if(this.stateToast){
        this.toastrService.remove(this.stateToast.toastId);
      }
      this.toastrService.info('Online', null, {timeOut: 5000});
    })
  }

  private handleOffline() {
    this.state = 'Offline';
    this.stateToast = this.toastrService.error('There might be ongoing IME update in progress or there is network failure', 'Offline', {disableTimeOut: true});
  }

  private addMessagesFromResponse(response: any) {
    if (response) {
      let apiResponse = response as ApiResponse<any>;

      if(apiResponse.status == 401) return;
      if(apiResponse.Errors?.length > 0 || apiResponse.Informations?.length > 0 || apiResponse.Warnings?.length > 0){
        this.response$.next(response);
      }
    }
  }
}
